// src/mixins/update.js
import store from '@/store'
export default {
	data () {
		return{
			amount: null,
			description: null,
			starting_balance: 0,
			mode: "neutral", //in , out or neutral
			activities: []
		}
	},
	computed: {
		drawer_running_amount (){
			return 	parseFloat(parseFloat(this.starting_balance) + store.state.cashdrawer_amount).toFixed(2)
		},
	},
	watch:{
		starting_balance: function(){
			localStorage.setItem('starting_balance',JSON.stringify(this.starting_balance))
		}
	},
	mounted(){
		var drawer_activity = localStorage.getItem('drawer_activity')
		if (! drawer_activity){
			localStorage.setItem('drawer_activity',"[]")
		}else {
			this.activities = JSON.parse(localStorage.getItem('drawer_activity'))
			this.activities.reverse()
		}
		this.$store.commit('new_drawer_entry') //simulate this to get latest result
		if (localStorage.getItem('starting_balance')){
			this.starting_balance = JSON.parse(localStorage.getItem('starting_balance'))
		}else {
			localStorage.setItem('starting_balance','0')
		}
	},
    methods: {
		setMode:function(value){
			this.mode = value
		},
		/* Set the width of the side navigation to 250px */
		openDrawer:function() {
			var drawer_div = document.getElementById("cashdrawer-div")
			drawer_div.style.width = "300px"
		},
		/* Set the width of the side notification div to 0 */
		closeDrawer:function() {
			var drawer_div = document.getElementById("cashdrawer-div")
			drawer_div.style.width = "0px"
		},
		recordCashOut: function(){
			var drawer_activity = localStorage.getItem('drawer_activity')
			var activities
			if (! drawer_activity){
				activities = []
			}else{
				activities = JSON.parse(drawer_activity)
			}
			activities.push({"status":"out","amount":this.amount,"description":this.description})
			localStorage.setItem('drawer_activity',JSON.stringify(activities))
			this.$store.commit('new_drawer_entry')
			this.activities = JSON.parse(localStorage.getItem('drawer_activity'))
			this.activities.reverse()
			this.mode = "neutral"
			this.amount = null
			this.description = null
		},
		recordCashIn: function(){
			var drawer_activity = localStorage.getItem('drawer_activity')
			var activities
			if (! drawer_activity){
				activities = []
			}else{
				activities = JSON.parse(drawer_activity)
			}
			activities.push({"status":"in","amount":this.amount,"description":this.description})
			localStorage.setItem('drawer_activity',JSON.stringify(activities))
			this.$store.commit('new_drawer_entry')
			this.activities = JSON.parse(localStorage.getItem('drawer_activity'))
			this.activities.reverse()
			this.mode = "neutral"
			this.amount = null
			this.description = null
		}
    },
}
